import { createElement, FC } from 'react'
import { IconType } from 'react-icons'
import { useLocation, useNavigate } from 'react-router-dom'

import { authSelector } from '../../redux/authSlice/authSlice'
import { openModal } from '../../redux/modelSlice/modelSlice'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
interface Props {
  to: string
  icon: IconType
  label: string
}
const FooterItem: FC<Props> = ({ to, icon, label }) => {
  const { isLoggedIn } = useAppSelector(authSelector)
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const location = useLocation()
  const handleClick = (to: string): void => {
    if (isLoggedIn) navigate(to)
    else dispatch(openModal())
  }
  return (
      <div onClick={() => { handleClick(to) }} className={`flex flex-col items-center`}>
        {createElement(icon, {
          color: location.pathname === to ? 'blue' : 'black',
          size: 20
        })}
        <p className={`text-[10px] font-bold ${location.pathname === to ? 'text-blue-600' : 'text-black'}`}>{label}</p>
      </div>
  )
}

export default FooterItem
